export const SESSION_TIMEOUT = 'Login/SESSION_TIMEOUT'

export const ON_INIT = 'Login/ON_INIT'
export const ON_INIT_ERROR = 'Login/ON_INIT_ERROR'
export const ON_INIT_SUCCESS = 'Login/ON_INIT_SUCCESS'

export const GET_BANNER_INFO = 'APP/GET_BANNER_INFO'
export const GET_BANNER_INFO_SUCCESS = 'APP/GET_BANNER_INFO_SUCCESS'
export const GET_BANNER_INFO_FAIL = 'APP/GET_BANNER_INFO_FAIL'
export const CLOSE_BANNER = 'APP/CLOSE_BANNER'

export const VALIDATE_SESSION = 'Login/VALIDATE_SESSION'
export const VALIDATE_SESSION_ERROR = 'Login/VALIDATE_SESSION_ERROR'
export const VALIDATE_SESSION_SUCCESS = 'Login/VALIDATE_SESSION_SUCCESS'

export const ON_AUTHENTICATE = 'Login/ON_AUTHENTICATE'
export const ON_AUTHENTICATE_ERROR = 'Login/ON_AUTHENTICATE_ERROR'
export const ON_AUTHENTICATE_SUCCESS = 'Login/ON_AUTHENTICATE_SUCCESS'

export const ON_VERIFY_AUTH_ACCOUNT_RECOVERY = 'Login/ON_VERIFY_AUTH_ACCOUNT_RECOVERY'

export const MAGIC_LINK_LOGIN = 'Login/MAGIC_LINK_LOGIN'
export const MAGIC_LINK_LOGIN_ERROR = 'Login/ON_REQUEST_LOGIN_MAGIC_LINK_ERROR'
export const MAGIC_LINK_LOGIN_SUCCESS = 'Login/ON_REQUEST_LOGIN_MAGIC_LINK_SUCCESS'

export const MAGIC_LINK_VERIFY = 'Login/MAGIC_LINK_VERIFY'
export const MAGIC_LINK_VERIFY_ERROR = 'Login/MAGIC_LINK_VERIFY_ERROR'
export const MAGIC_LINK_VERIFY_SUCCESS = 'Login/MAGIC_LINK_VERIFY_SUCCESS'

export const ON_VERIFY_AUTH_ACCOUNT_RECOVERY_ERROR = 'Login/ON_VERIFY_AUTH_ACCOUNT_RECOVERY_ERROR'
export const ON_VERIFY_AUTH_ACCOUNT_RECOVERY_SUCCESS = 'Login/ON_VERIFY_AUTH_ACCOUNT_RECOVERY_SUCCESS'

export const ON_VERIFY_ACCOUNT_RECOVERY = 'Login/ON_VERIFY_ACCOUNT_RECOVERY'
export const ON_VERIFY_ACCOUNT_RECOVERY_ERROR = 'Login/ON_VERIFY_ACCOUNT_RECOVERY_ERROR'
export const ON_VERIFY_ACCOUNT_RECOVERY_SUCCESS = 'Login/ON_VERIFY_ACCOUNT_RECOVERY_SUCCESS'
export const ON_VERIFY_ACCOUNT_RECOVERY_NEXT_STEP = 'Login/ON_VERIFY_ACCOUNT_RECOVERY_NEXT_STEP'

export const SET_AUTHENTICATOR = 'Login/SET_AUTHENTICATOR'
export const SET_OPTIONAL_AUTHENTICATOR = 'Login/SET_OPTIONAL_AUTHENTICATOR'

export const ON_BACK_AUTHENTICATORS = 'Login/ON_BACK_AUTHENTICATORS'
export const ON_BACK_OPTIONAL_AUTHENTICATORS = 'Login/ON_BACK_OPTIONAL_AUTHENTICATORS'
export const ON_BACK_FALLBACK_ENFORCE_MFA = 'Login/ON_BACK_FALLBACK_ENFORCE_MFA'
export const ON_BACK_FALLBACK_ENFORCE_MFA_TWO_STEPS = 'Login/ON_BACK_FALLBACK_ENFORCE_MFA_TWO_STEPS'

export const SET_DEVICE_TYPE = 'Login/SET_DEVICE_TYPE'

export const FORGOTPWD = 'Login/FORGOTPWD'
export const FORGOTPWD_SUCCESS = 'Login/FORGOTPWD_SUCCES'
export const FORGOTPWD_ERROR = 'Login/FORGOTPWD_ERROR'

export const INIT_ENROLL_AUTH_FACTOR = 'Login/INIT_ENROLL_AUTH_FACTOR'
export const INIT_ENROLL_AUTH_FACTOR_SUCCESS = 'Login/INIT_ENROLL_AUTH_FACTOR_SUCCESS'
export const INIT_ENROLL_AUTH_FACTOR_ERROR = 'Login/INIT_ENROLL_AUTH_FACTOR_ERROR'

export const QR_CODE_NEXT = 'Login/QR_CODE_NEXT'

export const QR_CODE_CANNOT_SCAN = 'Login/QR_CODE_CANNOT_SCAN'
export const QR_CODE_CANNOT_SCAN_NEXT = 'Login/QR_CODE_CANNOT_SCAN_NEXT'

export const ACTIVATE_AUTHENTICATOR_CODE = 'Login/ACTIVATE_AUTHENTICATOR_CODE'
export const ACTIVATE_AUTHENTICATOR_CODE_SUCCESS = 'Login/ACTIVATE_AUTHENTICATOR_CODE_SUCCESS'
export const ACTIVATE_AUTHENTICATOR_CODE_ERROR = 'Login/ACTIVATE_AUTHENTICATOR_CODE_ERROR'
export const ACTIVATE_AUTHENTICATOR_CODE_NEXT_STEP = 'Login/ACTIVATE_AUTHENTICATOR_CODE_NEXT_STEP'

export const VERIFY_AUTHENTICATOR_CODE = 'Login/VERIFY_AUTHENTICATOR_CODE'
export const VERIFY_AUTHENTICATOR_CODE_SUCCESS = 'Login/VERIFY_AUTHENTICATOR_CODE_SUCCESS'
export const VERIFY_AUTHENTICATOR_CODE_ERROR = 'Login/VERIFY_AUTHENTICATOR_CODE_ERROR'
export const VERIFY_AUTHENTICATOR_CODE_NEXT_STEP = 'Login/VERIFY_AUTHENTICATOR_CODE_NEXT_STEP'

export const RESET_AUTH_VERIFIED = 'Login/RESET_AUTH_VERIFIED'

export const VERIFY_PUSH = 'Login/VERIFY_PUSH'
export const VERIFY_PUSH_ERROR = 'Login/VERIFY_PUSH_ERROR'
export const VERIFY_PUSH_SUCCESS = 'Login/VERIFY_PUSH_SUCCESS'

export const SKIP_ENROLLMENT = 'Login/SKIP_ENROLLMENT'
export const SKIP_ENROLLMENT_SUCCESS = 'Login/SKIP_ENROLLMENT_SUCCESS'
export const SKIP_ENROLLMENT_ERROR = 'Login/SKIP_ENROLLMENT_ERROR'

export const ON_VERIFY_ACCOUNT_RECOVERY_AT_LOGIN = 'Login/ON_VERIFY_ACCOUNT_RECOVERY_AT_LOGIN'
export const ON_VERIFY_ACCOUNT_RECOVERY_AT_LOGIN_ERROR = 'Login/ON_VERIFY_ACCOUNT_RECOVERY_AT_LOGIN_ERROR'
export const ON_VERIFY_ACCOUNT_RECOVERY_AT_LOGIN_SUCCESS = 'Login/ON_VERIFY_ACCOUNT_RECOVERY_AT_LOGIN_SUCCESS'

export const ON_ENROLL_MFA = 'Login/ON_ENROLL_MFA'
export const ON_ENROLL_MFA_ERROR = 'Login/ON_ENROLL_MFA_ERROR'
export const ON_ENROLL_MFA_SUCCESS = 'Login/ON_ENROLL_MFA_SUCCESS'

export const ON_SEND_CHALLENGE = 'Login/ON_SEND_CHALLENGE'
export const ON_SEND_CHALLENGE_ERROR = 'Login/ON_SEND_CHALLENGE_ERROR'
export const ON_SEND_CHALLENGE_SUCCESS = 'Login/ON_SEND_CHALLENGE_SUCCESS'

export const ON_RESEND_AUTH_CHALLENGE = 'Login/ON_RESEND_AUTH_CHALLENGE'
export const ON_RESEND_AUTH_CHALLENGE_ERROR = 'Login/ON_RESEND_AUTH_CHALLENGE_ERROR'
export const ON_RESEND_AUTH_CHALLENGE_SUCCESS = 'Login/ON_RESEND_AUTH_CHALLENGE_SUCCESS'

export const ON_RESEND_CHALLENGE = 'Login/ON_RESEND_CHALLENGE'
export const ON_RESEND_CHALLENGE_ERROR = 'Login/ON_RESEND_CHALLENGE_ERROR'
export const ON_RESEND_CHALLENGE_SUCCESS = 'Login/ON_RESEND_CHALLENGE_SUCCESS'

export const INIT_AUTHENTICATORS = 'Login/INIT_AUTHENTICATORS'
export const INIT_AUTHENTICATORS_SUCCESS = 'Login/INIT_AUTHENTICATORS_SUCCESS'
export const INIT_AUTHENTICATORS_ERROR = 'Login/INIT_AUTHENTICATORS_ERROR'

export const ON_LOGIN_APP = 'Login/ON_LOGIN_APP'
export const ON_LOGIN_APP_SUCCESS = 'Login/ON_LOGIN_APP_SUCCESS'
export const ON_LOGIN_APP_ERROR = 'Login/ON_LOGIN_APP_ERROR'

export const GET_ACCOUNT_RECOVERY = 'Login/GET_ACCOUNT_RECOVERY'
export const GET_ACCOUNT_RECOVERY_SUCCESS = 'Login/GET_ACCOUNT_RECOVERY_SUCCESS'
export const GET_ACCOUNT_RECOVERY_ERROR = 'Login/GET_ACCOUNT_RECOVERY_ERROR'

export const ENROLL_MFA_INIT = 'Login/ENROLL_MFA_INIT'
export const ENROLL_MFA_INIT_SUCCESS = 'Login/ENROLL_MFA_INIT_SUCCESS'
export const ENROLL_MFA_INIT_FAILURE = 'Login/ENROLL_MFA_INIT_FAILURE'

export const VALIDATE_PHONE_AT_LOGIN = 'Login/VALIDATE_PHONE_AT_LOGIN'
export const VALIDATE_PHONE_AT_LOGIN_ERROR = 'Login/VALIDATE_PHONE_AT_LOGIN_ERROR'
export const VALIDATE_PHONE_AT_LOGIN_SUCCESS = 'Login/VALIDATE_PHONE_AT_LOGIN_SUCCESS'

